// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"7b06bdf4","668":"fe628fe8"}[chunkId] + ".chunk.js";
};